import React, { useEffect, useState, useRef } from 'react'
import {
	Box,
	Select,
	Stack,
	Input,
	HStack,
	IconButton,
	Spinner,
	Center,
	Text,
	Alert,
	AlertDialog,
	AlertDialogBody,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogContent,
	AlertDialogOverlay,
	Icon,
	Collapse,
	Button,
	useToast,
	Table,
	Thead,
	Tr,
	Th,
	Tbody,
	Td,
	Image,
	SimpleGrid,
	VStack,
	Flex
} from '@chakra-ui/react'
import {
	Pagination,
	usePagination,
	PaginationNext,
	PaginationPage,
	PaginationPrevious,
	PaginationContainer,
	PaginationPageGroup,
	PaginationSeparator,
} from '@ajna/pagination'
import AdminBlockCard from '../../components/AdminBlockCard'
import AdminBreadcrumb from '../../components/AdminBreadcrumb'
import AdminBusinessCard from '../../components/AdminBusinessCard'
import { GoSearch } from 'react-icons/go'
import { deleteRequest, getRequest, postRequest } from '../../services/base.service'
import { IoIosArrowBack } from 'react-icons/io'
import { IoIosArrowForward } from 'react-icons/io'
import { FiFilter, FiDelete, FiEdit, FiEye, FiEdit2, FiEdit3 } from 'react-icons/fi'
import { useDispatch } from 'react-redux'
import {
	setAdminSidebarFalseOnUrlChange,
	setCurrentPageHeading,
} from '../../redux/common/commonActions'
import { Select as SearchableSelect} from 'chakra-react-select'
import SearchBox from '../../components/SearchBox'
import { Link } from 'react-router-dom';
import { MdDeleteForever } from "react-icons/md";

const breadCrumb = [
	{ label: 'Dashboard', isCurrentPage: false, link: '/admin/dashboard' },
	{ label: 'Business List', isCurrentPage: true },
]

const BusinessList = () => {
	const [businessList, setBusinessList] = useState(null)
	const [deleteableBusinessId, setDeleteableBusinessId] = useState(null)
	const [showMobileActions, setShowMobileActions] = useState(false)
	const [paginationProperty, setPaginationProperty] = useState({
		total: 1,
		currentPage: 1,
		pageSize: 10,
	})
	const [spinner, setSpinner] = useState({ status: true })
	const [queryParams, setQueryParams] = useState({
		// sort: '',
	})
	const [alertDialogIsOpen, setAlertDialogIsOpen] = useState(false)
	const [countryList, setCountryList] = useState([])
	const [cityList, setCityList] = useState([])
	const [allStateList, setAllStateList] = useState([])
	const [industryList, setIndustryList] = useState([])
	const [stateList, setStateList] = useState([])
	const [selectedCountry, setSelectedCountry] = useState(null)

	const {
		pages,
		pagesCount,
		currentPage,
		setCurrentPage,
		isDisabled,
		setPageSize,
		pageSize
	} = usePagination({
		total: paginationProperty.total,
		limits: {
			outer: 2,
			inner: 2,
		},
		initialState: {
			pageSize: paginationProperty.pageSize,
			isDisabled: false,
			currentPage: 1,
		},
	})
	const dispatch = useDispatch()
	const toast = useToast()
	useEffect(() => {
		dispatch(setCurrentPageHeading('Business List'))
		dispatch(setAdminSidebarFalseOnUrlChange())
		fetchAllStateList()
		fetchCityList()
	}, [])

	useEffect(() => {
		fetchBusinessList({ page: currentPage, limit: pageSize })
		fetchCountryList()
		fetchIndustryList()
	}, [currentPage, pageSize])

	useEffect(() => {
		if (selectedCountry) {
			fetchStateList();
		}
	}, [selectedCountry])

	const fetchBusinessList = (params = {}) => {
		setSpinner({ status: true })
		getRequest('admin/businesses', { params })
			.then((res) => {
				setBusinessList(res.result?.data)
				setPaginationProperty({
					total: res.result.total,
					currentPage: res.result.current_page,
					pageSize: res.result.per_page,
				})
				setPageSize(res.result.per_page)
				setSpinner({ status: false })
			})
			.catch((err) => {
				console.log('ERR: ', err)
			})
	}

	const fetchCountryList = () => {
			getRequest(`countries`)
				.then((res) => setCountryList(res.result))
				.catch((err) => console.log('ERR: ', err))
	}

	const fetchCityList = () => {
			getRequest(`admin/cities`)
				.then((res) => setCityList(res.result.data))
				.catch((err) => console.log('ERR: ', err))
	}

	const fetchStateList = () => {
		getRequest(`states/${selectedCountry}`)
			.then((res) => {
				setStateList(res.result?.states)
				console.log('State List: ', res.result?.states)
			})
			.catch((err) => {
				console.log('ERR: ', err)
			})
	}

	const fetchIndustryList = () => {
			getRequest(`admin/industries`)
				.then((res) => setIndustryList(res.data))
				.catch((err) => console.log('ERR: ', err))
	}

	const fetchAllStateList = () => {
			getRequest(`admin/states`)
				.then((res) => setAllStateList(res.result.data))
				.catch((err) => console.log('ERR: ', err))
	}

	const handlePageChange = (nextPage) => {
		setCurrentPage(nextPage)
	}

	const handleSearch = (e) => {
		e.preventDefault()
		setCurrentPage(1)
		fetchBusinessList({ ...queryParams, page: 1, limit: pageSize })
	}

	function handleChange(key, event) {
		const value = event.target.value;
		setQueryParams({ ...queryParams, [key]: value })
		setSpinner({ status: true })
		setCurrentPage(1)
		fetchBusinessList({ ...queryParams, [key]: value, page: 1 })

		if (key === 'country_id') {
			setSelectedCountry(value);             
		}
	}

	const deleteBusiness = (businessId) => {
		console.log(businessId)
		setDeleteableBusinessId(businessId)
		setAlertDialogIsOpen(true)
	}

	const hideConfirmDialog = () => {
		setDeleteableBusinessId(null)
		setAlertDialogIsOpen(false)
	}

		const handleBusinessDeleteConfirm = () => {
			deleteRequest(`admin/business/${deleteableBusinessId}`)
				.then((res) => {
					
					hideConfirmDialog()
					toast({
						title: 'Status Changed.',
						description: res.message,
						status: 'success',
						duration: 5000,
						isClosable: true,
					})
					setCurrentPage(1)
					fetchBusinessList({ ...queryParams, page: 1 })

				})
				.catch((error) => {
					toast({
						title: 'Error',
						description: error.response.data.message || 'Something went wrong',
						status: 'error',
						duration: 5000,
						isClosable: true,
					})
					
				})
		}
		const cancelRef = useRef()

		const formatDate = (dateString) => {
			const date = new Date(dateString);
			const day = date.getDate();
			const month = date.toLocaleString('en-GB', { month: 'long' });
			const year = date.getFullYear();
			return `${day} ${month}, ${year}`;
		};
		const getCountryName = (id) => countryList.find(c => c.id === id)?.name || '';
		const getStateName = (id) => allStateList.find(s => s.id === id)?.name || '';
		const getCityName = (id) => cityList.find(c => c.id === id)?.name || '';

	const handleReset = () => {
		const defaultQuery = { keyword: '', country_id: '', state_id: '', industry_id: '', status: '', sort: '', address_keyword: '' }
		setQueryParams(defaultQuery)
		setCurrentPage(1)
		fetchBusinessList({ ...defaultQuery, page: 1 })
	}

	return (
		<>
			<AdminBreadcrumb items={breadCrumb} />
			{/* <Box py={'7'}> */}
				<SearchBox
					primaryActions={
						<>
							<HStack as={'form'} w="100%">
										<Input
											placeholder="Search..."
											w={['100%']} 
											size={'md'}
											borderColor={'gray.300'}
											rounded={'md'}
											onChange={(e) => {
												setQueryParams({
													...queryParams,
													keyword: e.target.value,
												})
											}}
										/>
										{/* <Box>
											<IconButton
												aria-label="Search"
												size={'md'}
												icon={<GoSearch />}
												variant={'brand'}
												type="submit"
												onClick={handleSearch}
											/>
										</Box> */}
							</HStack>
						</>
					}
					secondaryActions={
						<VStack as="form" spacing={4} w="100%" align="stretch">
							<SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} w="100%">
							<Select
								placeholder="Country"
								size="md"
								rounded={'md'}
								borderColor="gray.300"
								value={queryParams?.country_id || ''}
								// onChange={(e) => handleChange('country_id', e)}
								onChange={(e) => {
												setQueryParams({
													...queryParams,
													country_id: e.target.value,
												})
												setSelectedCountry(e.target.value)
								}}
							>
								{countryList.map((country) => (
								<option key={country.id} value={country.id}>
									{country.name}
								</option>
								))}
							</Select>
						
							<Select
								placeholder="State"
								size="md"
								rounded={'md'}
								borderColor="gray.300"
								value={queryParams?.state_id || ''}
								// onChange={(e) => handleChange('state_id', e)}
								onChange={(e) => {
												setQueryParams({
													...queryParams,
													state_id: e.target.value,
												})
								}}
							>
								{stateList.map((state) => (
								<option key={state.id} value={state.id}>
									{state.name}
								</option>
								))}
							</Select>
						
							<Input
								placeholder="Enter Area"
								size="md"
								rounded={'md'}
								borderColor="gray.300"
								value={queryParams?.address_keyword || ''}
								onChange={(e) =>
									setQueryParams({
										...queryParams,
										address_keyword: e.target.value,
									})
								}
							/>
						
							<Select
								placeholder="Industry"
								size="md"
								rounded={'md'}
								borderColor="gray.300"
								value={queryParams?.industry_id || ''}
								// onChange={(e) => handleChange('industry_id', e)}
								onChange={(e) =>
									setQueryParams({
										...queryParams,
										industry_id: e.target.value,
									})
								}
							>
								{industryList.map((industry) => (
								<option key={industry.id} value={industry.id}>
									{industry.name}
								</option>
								))}
							</Select>
						
							<Select
								placeholder="Status"
								size="md"
								rounded={'md'}
								borderColor="gray.300"
								value={queryParams?.status || ''}
								// onChange={(e) => handleChange('status', e)}
								onChange={(e) =>
									setQueryParams({
										...queryParams,
										status: e.target.value,
									})
								}
							>
								<option value="pending">Pending</option>
								<option value="approved">Approved</option>
								<option value="declined">Declined</option>
								<option value="blocked">Blocked</option>
							</Select>
						
							<Select
								placeholder="Sort By"
								size="md"
								rounded={'md'}
								borderColor="gray.300"
								value={queryParams?.sort || ''}
								// onChange={(e) => handleChange('sort', e)}
								onChange={(e) =>
									setQueryParams({
										...queryParams,
										sort: e.target.value,
									})
								}
							>
								<option value="desc">New</option>
								<option value="asc">Older</option>
							</Select>
							</SimpleGrid>
						
							{/* Buttons */}
							<HStack justify="flex-end" spacing={4}>

								<Button 
									variant="outline"
									colorScheme="gray" 
									size="md"				
									rounded={'md'}
									onClick={handleReset}
								>
									Reset
								</Button>
								<Button 
									variant={'brand'}
									size="md"
									rounded={'md'}
									type="submit" 
									onClick={handleSearch}
								>
									Search
								</Button>
							</HStack>
						</VStack>
					}
				>
				</SearchBox>
			{/* </Box> */}
			<Box py={'7'}>
								<AlertDialog
									isOpen={alertDialogIsOpen}
									leastDestructiveRef={cancelRef}
									onClose={hideConfirmDialog}
								>
									<AlertDialogOverlay>
										<AlertDialogContent>
											<AlertDialogHeader fontSize="lg" fontWeight="bold">
												Confirmation
											</AlertDialogHeader>
				
											<AlertDialogBody>
												Are you sure? You can't undo this action afterwards.
											</AlertDialogBody>
				
											<AlertDialogFooter>
												<Button ref={cancelRef} onClick={hideConfirmDialog}>
													Cancel
												</Button>
												<Button
													colorScheme={'red'}
													onClick={() => handleBusinessDeleteConfirm()}
													ml={3}
												>
													Confirm
												</Button>
											</AlertDialogFooter>
										</AlertDialogContent>
									</AlertDialogOverlay>
								</AlertDialog>
				<AdminBlockCard
					title={'Business List'}
					// primaryActions={
					// 	<>
					// 		{/* <HStack> */}
					// 			{/* <Select
					// 				display={['none', 'none', 'none', 'flex']}
					// 				placeholder="Country"
					// 				w={'120px'}
					// 				size={'sm'}
					// 				borderColor={'gray.300'}
					// 				value={queryParams?.country_id}
					// 				onChange={(e) => handleChange('country_id', e)}
					// 			>
					// 				{countryList.length > 0 &&
					// 					countryList.map((country) => (
					// 						<option key={country.id} value={country.id}>
					// 							{country.name}
					// 						</option>
					// 				))}
					// 			</Select>
					// 			<Select
					// 				display={['none', 'none', 'none', 'flex']}
					// 				placeholder="State"
					// 				w={'120px'}
					// 				size={'sm'}
					// 				borderColor={'gray.300'}
					// 				value={queryParams?.state_id}
					// 				onChange={(e) => handleChange('state_id', e)}
					// 			>
					// 				{stateList.length > 0 &&
					// 					stateList.map((state) => (
					// 						<option key={state.id} value={state.id}>
					// 							{state.name}
					// 						</option>
					// 				))}
					// 			</Select>
					// 			<Input
					// 				placeholder="Enter Area"
					// 				w={['100%', '100%', '100%', '120px']}
					// 				display={['none', 'none', 'none', 'flex']}
					// 				size="sm"
					// 				borderColor="gray.300"
					// 				value={queryParams?.address_keyword || ''}
					// 				onChange={(e) => {
					// 					setQueryParams({
					// 						...queryParams,
					// 						address_keyword: e.target.value,
					// 					})
					// 				}}
					// 			/>
					// 			<Select
					// 				display={['none', 'none', 'none', 'flex']}
					// 				placeholder="Status"
					// 				w={'120px'}
					// 				size={'sm'}
					// 				borderColor={'gray.300'}
					// 				value={queryParams?.status}
					// 				onChange={(e) => handleChange('status', e)}
					// 			>
					// 				<option value={'pending'}>Pending</option>
					// 				<option value={'approved'}>Approved</option>
					// 				<option value={'declined'}>Declined</option>
					// 				<option value={'blocked'}>Blocked</option>
					// 			</Select>
					// 			<Select
					// 				display={['none', 'none', 'none', 'flex']}
					// 				placeholder="Sort By"
					// 				w={'120px'}
					// 				size={'sm'}
					// 				borderColor={'gray.300'}
					// 				value={queryParams?.sort}
					// 				onChange={(e) => handleChange('sort', e)}
					// 			>
					// 				<option value={'desc'}>New</option>
					// 				<option value={'asc'}>Older</option>
					// 			</Select> */}
					// 			{/* <Input
					// 				placeholder="Enter Area"
					// 				w={['100%', '100%', '100%', '120px']}
					// 				display={['none', 'none', 'none', 'flex']}
					// 				size="sm"
					// 				borderColor="gray.300"
					// 				value={queryParams?.address_keyword || ''}
					// 				onChange={(e) => {
					// 					setQueryParams({
					// 						...queryParams,
					// 						address_keyword: e.target.value,
					// 					})
					// 				}}
					// 			/> */}
					// 			<HStack as={'form'}>
					// 				<Input
					// 					placeholder="Search..."
					// 					w={['100%', '100%', '200px', '850px']} 
					// 					size={'sm'}
					// 					borderColor={'gray.300'}
					// 					onChange={(e) => {
					// 						setQueryParams({
					// 							...queryParams,
					// 							keyword: e.target.value,
					// 						})
					// 					}}
					// 				/>
					// 				{/* <Box> */}
					// 					<IconButton
					// 						aria-label="Search"
					// 						size={'sm'}
					// 						icon={<GoSearch />}
					// 						variant={'brand'}
					// 						type="submit"
					// 						onClick={handleSearch}
					// 					/>
					// 				{/* </Box> */}
					// 			</HStack>
					// 			<Icon
					// 				as={FiFilter}
					// 				display={[
					// 					'inline-block',
					// 					'inline-block',
					// 					'inline-block',
					// 					'none',
					// 				]}
					// 				onClick={() => {
					// 					setShowMobileActions(!showMobileActions)
					// 				}}
					// 				_hover={{ cursor: 'pointer' }}
					// 			/>
					// 		{/* </HStack> */}
					// 	</>
					// }
					// secondaryActions={
					// 	<HStack wrap="wrap" spacing={2}>
					// 			<Select
					// 				display={['none', 'none', 'none', 'flex']}
					// 				placeholder="Country"
					// 				w={'120px'}
					// 				size={'sm'}
					// 				borderColor={'gray.300'}
					// 				value={queryParams?.country_id}
					// 				onChange={(e) => handleChange('country_id', e)}
					// 			>
					// 				{countryList.length > 0 &&
					// 					countryList.map((country) => (
					// 						<option key={country.id} value={country.id}>
					// 							{country.name}
					// 						</option>
					// 				))}
					// 			</Select>
					// 			<Select
					// 				display={['none', 'none', 'none', 'flex']}
					// 				placeholder="State"
					// 				w={'120px'}
					// 				size={'sm'}
					// 				borderColor={'gray.300'}
					// 				value={queryParams?.state_id}
					// 				onChange={(e) => handleChange('state_id', e)}
					// 			>
					// 				{stateList.length > 0 &&
					// 					stateList.map((state) => (
					// 						<option key={state.id} value={state.id}>
					// 							{state.name}
					// 						</option>
					// 				))}
					// 			</Select>
					// 			<Input
					// 				placeholder="Enter Area"
					// 				w={['100%', '100%', '100%', '120px']}
					// 				display={['none', 'none', 'none', 'flex']}
					// 				size="sm"
					// 				borderColor="gray.300"
					// 				value={queryParams?.address_keyword || ''}
					// 				onChange={(e) => {
					// 					setQueryParams({
					// 						...queryParams,
					// 						address_keyword: e.target.value,
					// 					})
					// 				}}
					// 			/>
					// 			<Select
					// 				display={['none', 'none', 'none', 'flex']}
					// 				placeholder="Industry"
					// 				w={'120px'}
					// 				size={'sm'}
					// 				borderColor={'gray.300'}
					// 				value={queryParams?.industry_id}
					// 				onChange={(e) => handleChange('industry_id', e)}
					// 			>
					// 				{industryList.length > 0 &&
					// 					industryList.map((industry) => (
					// 						<option key={industry.id} value={industry.id}>
					// 							{industry.name}
					// 						</option>
					// 				))}
					// 			</Select>
					// 			<Select
					// 				display={['none', 'none', 'none', 'flex']}
					// 				placeholder="Status"
					// 				w={'120px'}
					// 				size={'sm'}
					// 				borderColor={'gray.300'}
					// 				value={queryParams?.status}
					// 				onChange={(e) => handleChange('status', e)}
					// 			>
					// 				<option value={'pending'}>Pending</option>
					// 				<option value={'approved'}>Approved</option>
					// 				<option value={'declined'}>Declined</option>
					// 				<option value={'blocked'}>Blocked</option>
					// 			</Select>
					// 			<Select
					// 				display={['none', 'none', 'none', 'flex']}
					// 				placeholder="Sort By"
					// 				w={'120px'}
					// 				size={'sm'}
					// 				borderColor={'gray.300'}
					// 				value={queryParams?.sort}
					// 				onChange={(e) => handleChange('sort', e)}
					// 			>
					// 				<option value={'desc'}>New</option>
					// 				<option value={'asc'}>Older</option>
					// 			</Select>
					// 	</HStack>
					// }
					// mobileActions={
					// 	<Collapse
					// 		in={showMobileActions}
					// 		unmountOnExit={true}
					// 		animateOpacity
					// 	>
					// 		<HStack
					// 			display={[
					// 				`${showMobileActions ? 'flex' : 'none'}`,
					// 				`${showMobileActions ? 'flex' : 'none'}`,
					// 				`${showMobileActions ? 'flex' : 'none'}`,
					// 				'none',
					// 			]}
					// 			transition={'2s'}
					// 			direction="column"
					// 		>
					// 			<Select
					// 				placeholder="Country"
					// 				size="sm"
					// 				borderColor="gray.300"
					// 				value={queryParams?.country_id}
					// 				onChange={(e) => handleChange('country_id', e)}
					// 			>
					// 				{countryList.length > 0 &&
					// 					countryList.map((country) => (
					// 						<option key={country.id} value={country.id}>
					// 							{country.name}
					// 						</option>
					// 				))}
					// 			</Select>
					// 			<Select
					// 				placeholder="State"
					// 				size="sm"
					// 				borderColor="gray.300"
					// 				value={queryParams?.state}
					// 				onChange={(e) => handleChange('state_id', e)}
					// 			>
					// 				{stateList.length > 0 &&
					// 					stateList.map((state) => (
					// 						<option key={state.id} value={state.id}>
					// 							{state.name}
					// 						</option>
					// 				))}
					// 			</Select>
					// 			<Select
					// 				placeholder="Industry"
					// 				size="sm"
					// 				borderColor="gray.300"
					// 				value={queryParams?.industry_id}
					// 				onChange={(e) => handleChange('industry_id', e)}
					// 			>
					// 				{industryList.length > 0 &&
					// 					industryList.map((industry) => (
					// 						<option key={industry.id} value={industry.id}>
					// 							{industry.name}
					// 						</option>
					// 				))}
					// 			</Select>
					// 			<Input
					// 				placeholder="Enter Area"
					// 				size="sm"
					// 				borderColor="gray.300"
					// 				value={queryParams?.address_keyword || ''}
					// 				onChange={(e) => {
					// 					setQueryParams({
					// 						...queryParams,
					// 						address_keyword: e.target.value,
					// 					})
					// 				}}
					// 			/>
					// 			<Select
					// 				placeholder="Status"
					// 				size={'sm'}
					// 				borderColor={'gray.300'}
					// 				value={queryParams?.status}
					// 				onChange={(e) => handleChange('status', e)}
					// 			>
					// 				<option value={'pending'}>Pending</option>
					// 				<option value={'approved'}>Approved</option>
					// 				<option value={'declined'}>Declined</option>
					// 				<option value={'blocked'}>Blocked</option>
					// 			</Select>
					// 			<Select
					// 				placeholder="Sort By"
					// 				size={'sm'}
					// 				borderColor={'gray.300'}
					// 				value={queryParams?.sort}
					// 				onChange={(e) => handleChange('sort', e)}
					// 			>
					// 				<option value={'desc'}>New</option>
					// 				<option value={'asc'}>Older</option>
					// 			</Select>
					// 		</HStack>
					// 	</Collapse>
					// }
				>
					{spinner.status ? (
						<Center>
							<Spinner color="red.500" size="xl" speed="0.6s" />
						</Center>
					) : businessList.length > 0 ? (
						<>
							<Stack gap={2} rounded={'md'} overflow={'auto'} border={'1px'} borderColor="gray.200">
								{/* {businessList?.map((business, index) => (
									<AdminBusinessCard
										key={index}
										companyName={business?.name}
										data={business}
										onDelete={deleteBusiness}
									/>
								))} */}
								<Table
									variant="simple"
									w={'100%'}
								>
									<Thead bg="gray.100">
										<Tr>
											<Th>Logo</Th>
											<Th>Id</Th>
											<Th>Name</Th>
											<Th>Address</Th>
											<Th>Created</Th>
											<Th> Last Updated</Th>
											<Th>Status</Th>
											<Th textAlign="right">Actions</Th>
										</Tr>
									</Thead>
									<Tbody>
										{businessList.map((business, index) => (
											<Tr key={business.id} bg={index % 2 === 0 ? 'gray.50' : 'white'}>
												<Td>
													<Image
														src={business.logo}
														alt={business.name}
														boxSize="50px"
														objectFit="contain"
													/>
												</Td>
												<Td>{business.id}</Td>
												<Td>{business.name}</Td>
												{/* <Td>{getCityName(business.city_id)}, {getStateName(business.state_id)}, {getCountryName(business.country_id)}</Td> */}
												<Td>{[
													business?.city?.name,
													business?.state?.name,
													business?.country?.name
													].filter(Boolean).join(', ')}
												</Td>												
												<Td>{formatDate(business.created_at)}</Td>
												<Td>{formatDate(business.updated_at)}</Td>
												<Td>{business.status}</Td>
												<Td key={business.id}>
													<HStack
														textAlign="right"
														align="right"
														justify="right"
														gap={2}
													>
														<Link to={`/admin/business-list/details/${business.id}`}>
															<FiEye cursor="pointer" />
														</Link>
														{/* <FiEdit2/> */}
														<MdDeleteForever
															size={21}
															cursor="pointer"
															onClick={() => deleteBusiness(business.id)}
														/>
													</HStack>
												</Td>												
											</Tr>
										))}
									</Tbody>									
								</Table>								

							</Stack>
							<Flex justify="space-between" align="center" mt={4} px={2} flexWrap="wrap" gap={2}>
							<HStack>
								<Select
									size="sm"
									width="fit-content"
									rounded="md"
									value={paginationProperty.pageSize}
									onChange={(e) => {
										setPageSize(Number(e.target.value));
										setCurrentPage(1);
									}}
								>
									{[10, 20, 50, 100].map((size) => (
										<option key={size} value={size}>
										{size}
										</option>
									))}
								</Select>
								<Text fontSize="sm" color="gray.600">
								Viewing {(currentPage - 1) * paginationProperty.pageSize + 1} to{' '}
								{Math.min(currentPage * paginationProperty.pageSize, paginationProperty.total)} of{' '}
								{paginationProperty.total} data
								</Text>
							</HStack>
							<Pagination
								pagesCount={pagesCount}
								currentPage={currentPage}
								isDisabled={isDisabled}
								onPageChange={handlePageChange}
							>
								<PaginationContainer align="center" justify="right" p={4}>
									<PaginationPrevious
										px={'2'}
										_hover={{
											bg: 'gray.100',
										}}
										bg="white"
										color="gray.700"
										_disable={{ bg: 'white' }}
									>
										<Text>
											<IoIosArrowBack />
										</Text>
									</PaginationPrevious>
									<PaginationPageGroup
										isInline
										align={'center'}
										mx={'1'}
										separator={
											<PaginationSeparator fontSize="sm" w={7} jumpSize={11} />
										}
									>
										{pages.map((page) => (
											<PaginationPage
												w={7}
												h={7}
												bg={'gray.200'}
												border={'1px'}
												borderColor={'gray.300'}
												key={`pagination_page_${page}`}
												page={page}
												color={'black.500'}
												fontSize={'sm'}
												_hover={{
													bg: 'brand.600',
													color: 'white',
												}}
												_current={{
													bg: 'brand.500',
													fontSize: 'sm',
													color: 'white',
													borderColor: 'brand.500',
												}}
											/>
										))}
									</PaginationPageGroup>
									<PaginationNext
										w={7}
										h={7}
										_hover={{
											bg: 'gray.100',
										}}
										bg="white"
										color="gray.700"
										_disable={{ bg: 'white' }}
									>
										<Text>
											<IoIosArrowForward />
										</Text>
									</PaginationNext>
								</PaginationContainer>
							</Pagination>
							</Flex>
						</>
					) : (
						<Alert status="error">
							<Center h={'100%'} w={'100%'}>
								NO DATA FOUND.
							</Center>
						</Alert>
					)}
				</AdminBlockCard>
			</Box>
		</>
	)
}

export default BusinessList
